import {FC, useState, createContext, useContext, useEffect} from 'react'
import {WithChildren} from '../../../../_metronic/helpers'
import {FilterDate, TSaleSummaryReportsResponse} from './_models'
import {getSaleSummaryReportById} from './_requests'

interface IFormContext {
  saleSummary: TSaleSummaryReportsResponse | undefined
  setSaleSummary: React.Dispatch<React.SetStateAction<TSaleSummaryReportsResponse | undefined>>
  getDataSaleSummary: (filter: string) => void

  filterDates: FilterDate | undefined
  setFilterDates: React.Dispatch<React.SetStateAction<FilterDate | undefined>>

  loading: boolean
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const FormContext = createContext<IFormContext>({} as IFormContext)

const FormProvider: FC<WithChildren> = ({children}) => {
  const [saleSummary, setSaleSummary] = useState<TSaleSummaryReportsResponse>()
  const [filterDates, setFilterDates] = useState<FilterDate>()
  const [loading, setLoading] = useState(false)

  const getDataSaleSummary = async (filter: string) => {
    const data = await getSaleSummaryReportById(filter)
    setSaleSummary(data['data'])
    setFilterDates(data['filterDates'])
  }

  return (
    <FormContext.Provider
      value={{
        saleSummary,
        setSaleSummary,
        filterDates,
        setFilterDates,
        getDataSaleSummary,
        loading,
        setLoading,
      }}
    >
      {children}
    </FormContext.Provider>
  )
}

const useForm = () => useContext(FormContext)

export {FormProvider, useForm}
